import React, { useEffect, useState } from "react";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import { FaSearch } from "react-icons/fa";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import { getInvoice } from "../../Actions/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";
import { subscriptionColors } from "../../Reducers/reducers";

const Transactions = () => {
  const { invoice, loader, loginData } = useSelector(
    (state) => state.userReducer
  );
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [reporttype, setreporttype] = useState("");

  const filteredTransactions = invoice?.filter((transaction) => {
    const matchesSearch = transaction.invoiceNumber
      ?.toLowerCase()
      .includes(search.toLowerCase());

    const matchesReportType =
      !reporttype || transaction?.client?.subscriptionType === reporttype;

    return matchesSearch && matchesReportType;
  });
  const reportOptions = [
    { value: "", label: "All" },
    { label: "Free Forever", value: "Free Forever" },
    { label: "Repotal Pro", value: "Repotal Pro" },
    { label: "Repotal Ultimate", value: "Repotal Ultimate" },
  ];

  const handleChanges = (selectedOption, setterFunction) => {
    setterFunction(selectedOption.value);
  };

  const selectedReportOption = reportOptions?.find(
    (option) => option.value === reporttype
  );
  useEffect(() => {
    dispatch(getInvoice(loginData?.accessToken));
  }, []);
  console.log(invoice, "pp");
  return (
    <ParentComponent>
      <PrimaryHeader />

      <div className="bg-white shadow-md rounded-lg">
        <div className="p-4 flex flex-col md:flex-row md:space-x-6 space-y-4 md:space-y-0">
          <div className="relative  sm:w-full md:w-8/12">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full"
            />
          </div>

          {/* <select
            value={reporttype}
            onChange={(e) => setreporttype(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 w-full md:w-3/12"
          >
            <option value="Report Type">Report Type</option>
            <option value="Sales Report">Sales Report</option>
            <option value="Inventory Report">Inventory Report</option>
          </select> */}
          <div className="w-full sm:w-full md:w-4/12">
            <DropDownCustom
              isClient={true}
              isAligned={true}
              selectedValue={selectedReportOption}
              handleChanges={(option) => handleChanges(option, setreporttype)}
              options={reportOptions}
              isSearchable={false}
              label="Subscription Type"
              placeholder="Select Subscription Type"
            />
          </div>
        </div>

        <div className="overflow-x-auto min-w-full">
          <table className="min-w-full text-left">
            <thead className="bg-[#361D3214]">
              <tr>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[100px]">
                  Transaction ID
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[250px]">
                  Company Name
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[180px] text-center ">
                  Subscription Type
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center ">
                  Payment Date
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center ">
                  Amount (AED)
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px]">
                  Payment Method
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredTransactions?.length > 0 ? (
                filteredTransactions?.map((transaction) => (
                  <tr key={transaction.id} className="border-b">
                    <td className="py-3 px-4 text-sm font-medium text-gray-800 min-w-[100px]">
                      {transaction.invoiceNumber}
                    </td>
                    <td className="py-3 px-4 text-sm font-medium text-gray-800 min-w-[250px]">
                      {transaction?.client?.businessName}
                    </td>
                    <td className="py-4 min-w-[100px] text-center ">
                      <span
                        className={`px-3 py-1 rounded-md text-xs font-semibold self-center shadow-sm  ${
                          subscriptionColors[transaction.subscriptionType]
                        }`}
                      >
                        {transaction?.subscriptionType}
                      </span>
                    </td>
                    <td className="py-3  text-sm font-normal text-gray-800 min-w-[150px] text-center ">
                      {moment(transaction?.invoiceDate).format("DD-MMM-yy")}
                    </td>
                    <td className="py-3  text-sm font-normal text-gray-800 min-w-[100px] text-center ">
                      AED {transaction.amount / 100}
                    </td>
                    <td className="py-3 pl-10 text-sm font-normal text-gray-800 min-w-[150px]">
                      {transaction?.paymentMethod}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-gray-500 py-4">
                    No transaction found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </ParentComponent>
  );
};

export default Transactions;
